import { createSelector } from '@reduxjs/toolkit'

import { selectBusinessPriorities } from './selectBusinessPriorities'
import { selectBusinessPrioritiesState } from './selectBusinessPrioritiesState'

export const selectEditingPriority = createSelector(
  [selectBusinessPriorities, selectBusinessPrioritiesState],
  (records, state) => records.find((r) => r.uid === state.editingPriorityId)
)
